// Alpine controller for the homepage testimonials "praise-picker" widget.
//
// The widget lets an operator choose which of the site-wide extracted PRAISE
// STRINGS to highlight in the testimonials section (top_praises field). The pool is
// a plain string[] (not rich objects), and the selection is an ordered string[] (up
// to MAX 6). Each item renders as a chip rather than a review card.
//
// TRANSACTIONAL shell (working copy + pre-edit snapshot + ONE whole-value
// cms-image-changed on confirm) is shared with review-picker and theme-quote-picker
// via createTransactionalPicker(); this file supplies only the praise-specific
// available()/add()/remove(). No cross-list drag.

import { createTransactionalPicker, poolPickerMethods } from "./transactional-picker";
import { parseJsonOr } from "../shared/utils";

interface CMSPraisePickerConfig {
  field: string;
  // Autosave routing key — threaded into the cms-image-changed detail so the
  // cmsEditor controller routes the write to the right section overlay.
  target: string;
  // Raw JSON strings from the widget ctx (parsed here so the templ never has to
  // build nested Alpine literals): pool = string[], selected = string[] (the
  // ordered top_praises).
  pool: string;
  selected: string;
  max?: number;
}

const MAX = 6;

export function cmsPraisePicker(config: CMSPraisePickerConfig) {
  const pool = parseJsonOr(config.pool, [] as string[]);
  const selected = parseJsonOr(config.selected, [] as string[]);

  return {
    ...createTransactionalPicker<string>({
      field: config.field,
      target: config.target,
      selected,
      max: config.max ?? MAX,
    }),
    // available()/add()/remove(): shared click-to-add/remove POOL logic. Praises
    // ARE the stored strings (the pool item is its own key) and the search box
    // filters the praise string itself.
    ...poolPickerMethods<string>({
      keyOf: (p) => p,
      matches: (p, q) => p.toLowerCase().includes(q),
    }),
    pool,
  };
}
